import { render, staticRenderFns } from "./AdminTextoEditable.vue?vue&type=template&id=0fbc39d2&scoped=true"
import script from "./AdminTextoEditable.vue?vue&type=script&lang=js"
export * from "./AdminTextoEditable.vue?vue&type=script&lang=js"
import style0 from "./AdminTextoEditable.vue?vue&type=style&index=0&id=0fbc39d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc39d2",
  null
  
)

export default component.exports